import type { ParkingRecord } from '@/services/dto';
import { addCommaAfterNumber } from '@/utils/parking';
import { useTranslation } from 'react-i18next';
import { useTickSoundInteraction } from '@/hooks';

interface ParkingResultCardProps {
    result: ParkingRecord;
    onClick: (result: ParkingRecord) => void;
    totalResults?: number;
}

export default function ParkingResultCard({ result, onClick, totalResults }: ParkingResultCardProps) {
    const { t } = useTranslation();
    const { handleInteraction, handleKeyboardInteraction } = useTickSoundInteraction();
    const formattedLicenseplate = addCommaAfterNumber(result.licenseplate);
    const { playTick } = useTickSoundInteraction();

    // Dynamic width based on total results
    const dynamicWidth = totalResults && totalResults > 3 ? 'widescreen:w-[calc(656*var(--vw-unit))]' : 'widescreen:w-[calc(698*var(--vw-unit))]';
    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            tabIndex={3}
            data-interactive
            aria-label={`${t('parking.vehicleNumber')} ${formattedLicenseplate}`}
            className={`h-[calc(134*var(--vh-unit))] w-[calc(360*var(--vw-unit))] ${dynamicWidth} widescreen:pb-[calc(44*var(--vh-unit))] widescreen:h-[calc(160*var(--vh-unit))] widescreen:pt-[calc(24*var(--vh-unit))] widescreen:flex-col widescreen:items-center widescreen:gap-[calc(10*var(--vh-unit))] widescreen:self-stretch focus-border  rounded-[calc(12*var(--vh-unit))] border-[calc(1*var(--vh-unit))] border-[var(--color-border-gray-ccc)] bg-[var(--color-bg-white)] pt-[calc(12*var(--vh-unit))] pr-[calc(20*var(--vw-unit))] pb-[calc(32*var(--vh-unit))] pl-[calc(20*var(--vw-unit))]`}
            onClick={(e) => handleInteraction(e, () => onClick(result))}
            data-type="button"
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    playTick();
                    e.preventDefault();
                }
                handleKeyboardInteraction(e, () => onClick(result));
            }}
        >
            <div className="text-center">
                <div className="mb-[calc(10*var(--vh-unit))] text-[calc(20*var(--vh-unit))] leading-[calc(28*var(--vh-unit))] font-medium text-[var(--color-text-main01)]">
                    {t('parking.vehicleNumber')}
                </div>
                <div className="text-[calc(40*var(--vh-unit))] leading-[calc(52*var(--vh-unit))] font-bold text-[var(--color-text-main01)]">
                    <span className="number">{result.licenseplate}</span>
                </div>
            </div>
        </div>
    );
}
